import { WEB_URL } from "@/config/endpoints";

export function getBreadcrumbSchema({ homeUrl, chapterName, page }) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": WEB_URL
      },
      {
        "@type": "ListItem",
        "position": 2,
        name:
          `${WEB_URL}/${page}` === "/hts-code"
            ? "HTS Codes"
            : page.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
        item: `${WEB_URL}/${page}`,
        "item": `${WEB_URL}/${page}`
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": chapterName
      }
    ]
  };
}
